var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "15px",
    viewBox: "0 0 25 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icView") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.4405866,179.085736 C51.8013522,179.461716 51.9999997,179.963987 51.9999997,180.499679 C52.0003016,181.035691 51.8016541,181.537962 51.4408885,181.914264 C49.6853638,183.744034 45.0077888,188 39.5,188 C33.9919093,188 29.3146362,183.744355 27.5594134,181.914585 C27.1983459,181.538284 26.9996984,181.036013 27.0000003,180.5 C27.0000003,179.963987 27.1986478,179.462038 27.5594134,179.086058 C29.3146362,177.256288 33.9922112,173 39.5,173 C45.0074869,173 49.6850619,177.255966 51.4405866,179.085736 Z M39.5,176.004627 C37.171175,176.004627 35.2767783,178.021102 35.2767783,180.5 C35.2767783,182.978898 37.171175,184.995373 39.5,184.995373 C41.828825,184.995373 43.7232217,182.978898 43.7232217,180.5 C43.7232217,178.021102 41.8285231,176.004627 39.5,176.004627 Z M39.5,183.592035 C37.8984423,183.592035 36.5951577,182.204765 36.5951577,180.5 C36.5951577,178.795235 37.8981404,177.407965 39.5,177.407965 C41.1018596,177.407965 42.4048423,178.794914 42.4048423,180.5 C42.4048423,182.205086 41.1015577,183.592035 39.5,183.592035 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Views-Swipe-Copy-2",
    transform: "translate(-27.000000, -173.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icView",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcView);
export default __webpack_public_path__ + "static/media/icView.8ac8f7230af30f94db8679b82d7e16ce.svg";
export { ForwardRef as ReactComponent };